import { Modal, Box, IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

const ModalImagenes = ({ open, handleClose, imagenes }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: "0px",
        left: "0px",
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1300,
      }}>
        <Box sx={{
          //width: "90%",
          //height: "95vh",
          position: "relative",
          backgroundColor: "white",
          borderRadius: "8px",
          alignContent: "center",
          padding: "16px",
          height: { xs: "75vh", lg: "95vh"},
          width: { xs: "90%", md:"80%", lg: "45%"},
        }}>

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: "8px",
              right: "8px",
              float: "right",
              color: "#ffffff",
              backgroundColor: "#D6001C",
              padding: "8px",
              borderRadius: "50%",
              overflow: "visible",
              transition: '0.3s',
              '&:hover': {
                bgcolor: 'secondary.main',
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box sx={{
            gap: "16px",
            overflowY: "auto",
            alignItems: "center",
            flexDirection: "column",
            //maxHeight: "85vh",
            maxHeight: { xs: "61vh", lg: "90vh"},
            display: "flex",
          }}>

            {imagenes.map((item) => (
              <Box
                key={item.id}
                component="img"
                src={item.imagen}
                //alt="modal promocional"
                loading="lazy"
                sx={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            ))}

          </Box>

        </Box>
      </Box>
    </Modal>
  );
};

export default ModalImagenes;